<template>
  <v-menu
    v-if="hint"
    open-on-hover
    min-width="200"
    :max-width="hintWidth"
    :open-delay="200"
    transition="slide-y-transition"
    bottom
    :left="direction === 'left'"
    :right="direction === 'right'"
    offset-y
    :nudge-bottom="nudgeBottom"
    :nudge-right="nudgeRight"
    rounded="lg"
    content-class=""
    :auto="positionAuto"
  >
    <template v-slot:activator="{ on }">
      <v-icon
        v-on="on"
        color="#ffd000"
        class="icon-hint pointer"
        :class="classList"
        :style="{top: `${iconTop}px`}"
      >
        mdi-help-circle-outline
      </v-icon>
    </template>
    <InfoAlert :hint="hint" />
  </v-menu>
</template>

<script>
import { getHint } from "@/util/hints";
import InfoAlert from "./InfoAlert.vue";
export default {
  name: "TooltipInputHint",
  components: { InfoAlert },
  props: {
    hintCode: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    maxWidth: {
      type: Number,
      default: 340
    },
    nudgeBottom: {
      type: Number,
      default: 8
    },
    nudgeRight: {
      type: Number,
      default: 14
    },
    classList: {
      type: String,
      default: ""
    },
    autoWidth: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: "left"
    },
    iconTop: {
      type: Number,
      default: 0
    },
    positionAuto: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: true
    };
  },
  computed: {
    hint() {
      return this.hintCode ? getHint(this.hintCode) : this.text;
    },
    maxWidthAuto() {
      const signsCount = this.hint?.length;
      let width = 340;
      if (signsCount > 200) {
        width = 600;
      }
      if (signsCount > 500) {
        width = 800;
      }
      return width;
    },
    hintWidth() {
      return this.autoWidth ? this.maxWidthAuto : this.maxWidth;
    }
  }
};
</script>
